var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-card",
    { staticClass: "pa-4", attrs: { flat: "" } },
    [
      _c("v-card-title", { staticClass: "pb-2" }, [
        _c("h3", [_vm._v("Cable Details")]),
      ]),
      _c("base-form", {
        ref: "cableFormRef",
        on: { submit: _vm.saveCable },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function ({ invalid }) {
              return [
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      { attrs: { cols: "12", md: "6" } },
                      [
                        _c("base-text-field", {
                          attrs: {
                            label: "Cable Title",
                            value: _vm.cableForm.title,
                            rules: "required",
                            placeholder: "Enter cable title",
                            disabled: _vm.readonly,
                          },
                          on: {
                            "update:value": function ($event) {
                              return _vm.$set(_vm.cableForm, "title", $event)
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      { attrs: { cols: "12", md: "6" } },
                      [
                        _c("base-text-field", {
                          attrs: {
                            label: "Cable Model No",
                            value: _vm.cableForm.cableModelNo,
                            placeholder: "Enter cable model number",
                            disabled: _vm.readonly,
                          },
                          on: {
                            "update:value": function ($event) {
                              return _vm.$set(
                                _vm.cableForm,
                                "cableModelNo",
                                $event
                              )
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      { attrs: { cols: "12", md: "6" } },
                      [
                        _c("base-text-field", {
                          attrs: {
                            label: "Cable Type",
                            value: _vm.cableForm.cableType,
                            placeholder: "Enter cable type",
                            disabled: _vm.readonly,
                          },
                          on: {
                            "update:value": function ($event) {
                              return _vm.$set(
                                _vm.cableForm,
                                "cableType",
                                $event
                              )
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      { attrs: { cols: "12", md: "6" } },
                      [
                        _c("base-text-field", {
                          attrs: {
                            label: "Cable Manufacturer",
                            value: _vm.cableForm.cableManufacturer,
                            placeholder: "Enter manufacturer name",
                            disabled: _vm.readonly,
                          },
                          on: {
                            "update:value": function ($event) {
                              return _vm.$set(
                                _vm.cableForm,
                                "cableManufacturer",
                                $event
                              )
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      { attrs: { cols: "12", md: "6" } },
                      [
                        _c("base-text-field", {
                          attrs: {
                            label: "Cable Length (m)",
                            value: _vm.cableForm.cableLength,
                            type: "number",
                            placeholder: "Enter cable length in meters",
                            disabled: _vm.readonly,
                          },
                          on: {
                            "update:value": function ($event) {
                              return _vm.$set(
                                _vm.cableForm,
                                "cableLength",
                                $event
                              )
                            },
                            input: () => {
                              _vm.calcCapacitance()
                              _vm.calcInductance()
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      { attrs: { cols: "12" } },
                      [
                        _c(
                          "v-row",
                          [
                            _c(
                              "v-col",
                              { attrs: { cols: "12", md: "6" } },
                              [
                                _c("base-text-field", {
                                  attrs: {
                                    label: "Capacitance per Meter (μF/m)",
                                    value:
                                      _vm.cableForm.cableCapacitancePerMeter,
                                    type: "number",
                                    placeholder: "Enter capacitance per meter",
                                    disabled: _vm.readonly,
                                  },
                                  on: {
                                    "update:value": function ($event) {
                                      return _vm.$set(
                                        _vm.cableForm,
                                        "cableCapacitancePerMeter",
                                        $event
                                      )
                                    },
                                    input: _vm.calcCapacitance,
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "v-col",
                              { attrs: { cols: "12", md: "6" } },
                              [
                                _c("base-text-field", {
                                  attrs: {
                                    label: "Inductance per Meter (mH/m)",
                                    value:
                                      _vm.cableForm.cableInductancePerMeter,
                                    type: "number",
                                    placeholder: "Enter inductance per meter",
                                    disabled: _vm.readonly,
                                  },
                                  on: {
                                    "update:value": function ($event) {
                                      return _vm.$set(
                                        _vm.cableForm,
                                        "cableInductancePerMeter",
                                        $event
                                      )
                                    },
                                    input: _vm.calcInductance,
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      { attrs: { cols: "12" } },
                      [
                        _c(
                          "v-row",
                          [
                            _c(
                              "v-col",
                              { attrs: { cols: "12", md: "6" } },
                              [
                                _c("base-text-field", {
                                  attrs: {
                                    label: "Total Capacitance of Cable (μF)",
                                    value: _vm.cableForm.cableCapacitance,
                                    type: "number",
                                    readonly: "",
                                  },
                                  on: {
                                    "update:value": function ($event) {
                                      return _vm.$set(
                                        _vm.cableForm,
                                        "cableCapacitance",
                                        $event
                                      )
                                    },
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "v-col",
                              { attrs: { cols: "12", md: "6" } },
                              [
                                _c("base-text-field", {
                                  attrs: {
                                    label: "Total Inductance of Cable (mH)",
                                    value: _vm.cableForm.cableInductance,
                                    type: "number",
                                    readonly: "",
                                  },
                                  on: {
                                    "update:value": function ($event) {
                                      return _vm.$set(
                                        _vm.cableForm,
                                        "cableInductance",
                                        $event
                                      )
                                    },
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      { attrs: { cols: "12", md: "4" } },
                      [
                        _c(
                          "v-radio-group",
                          {
                            attrs: {
                              row: "",
                              label: "Cable Screen",
                              disabled: _vm.readonly,
                            },
                            model: {
                              value: _vm.cableForm.cableScreen,
                              callback: function ($$v) {
                                _vm.$set(_vm.cableForm, "cableScreen", $$v)
                              },
                              expression: "cableForm.cableScreen",
                            },
                          },
                          [
                            _c("v-radio", {
                              attrs: {
                                color: "#1b3054",
                                label: "Yes",
                                value: true,
                              },
                            }),
                            _c("v-radio", {
                              attrs: {
                                color: "#1b3054",
                                label: "No",
                                value: false,
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      { attrs: { cols: "12", md: "4" } },
                      [
                        _c(
                          "v-radio-group",
                          {
                            attrs: {
                              row: "",
                              label: "Cable Armour",
                              disabled: _vm.readonly,
                            },
                            model: {
                              value: _vm.cableForm.cableAmour,
                              callback: function ($$v) {
                                _vm.$set(_vm.cableForm, "cableAmour", $$v)
                              },
                              expression: "cableForm.cableAmour",
                            },
                          },
                          [
                            _c("v-radio", {
                              attrs: {
                                color: "#1b3054",
                                label: "Yes",
                                value: true,
                              },
                            }),
                            _c("v-radio", {
                              attrs: {
                                color: "#1b3054",
                                label: "No",
                                value: false,
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      { attrs: { cols: "12", md: "4" } },
                      [
                        _c(
                          "v-radio-group",
                          {
                            attrs: {
                              row: "",
                              label: "Core Screen",
                              disabled: _vm.readonly,
                            },
                            model: {
                              value: _vm.cableForm.coreScreen,
                              callback: function ($$v) {
                                _vm.$set(_vm.cableForm, "coreScreen", $$v)
                              },
                              expression: "cableForm.coreScreen",
                            },
                          },
                          [
                            _c("v-radio", {
                              attrs: {
                                color: "#1b3054",
                                label: "Yes",
                                value: true,
                              },
                            }),
                            _c("v-radio", {
                              attrs: {
                                color: "#1b3054",
                                label: "No",
                                value: false,
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      { attrs: { cols: "12", md: "6" } },
                      [
                        _c("base-text-field", {
                          attrs: {
                            label: "Connected From Location ID",
                            value:
                              _vm.selectedCable?.locationConnection
                                ?.fromLocation?.title,
                            disabled: "",
                            readonly: "",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      { attrs: { cols: "12", md: "6" } },
                      [
                        _c("base-text-field", {
                          attrs: {
                            label: "Connected To Location ID",
                            value:
                              _vm.selectedCable?.locationConnection?.toLocation
                                ?.title,
                            disabled: "",
                            readonly: "",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                !_vm.readonly
                  ? _c(
                      "v-row",
                      { staticClass: "mt-4" },
                      [
                        _c(
                          "v-col",
                          {
                            staticClass: "d-flex justify-end",
                            attrs: { cols: "12" },
                          },
                          [
                            _c(
                              "v-btn",
                              {
                                staticClass: "mr-3",
                                attrs: {
                                  color: "grey",
                                  outlined: "",
                                  disabled: _vm.isLoading,
                                },
                                on: { click: _vm.resetForm },
                              },
                              [_vm._v("Reset")]
                            ),
                            _c(
                              "v-btn",
                              {
                                attrs: {
                                  color: "primary",
                                  type: "submit",
                                  loading: _vm.isLoading,
                                  disabled: invalid,
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.isEditing
                                        ? "Update Cable"
                                        : "Create Cable"
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }